'use strict';

export default function Select({
    keyPrefix = '',
    items,
    value,
    onChange,
    parentClass = '',
    selectClass = '',
    dropdownClass = '',
    required = false,
    disabled = false,
    error = undefined,
    errorClass = 'error_border',
    useBodyAsParent = false,
    escapeMarkup = false,
    formatListOptionCode = false,
}) {

    const parentRef = React.useRef()
    const selectRef = React.useRef()

    React.useEffect(() => {

        const parent = !useBodyAsParent && parentRef && parentRef.current ? $(parentRef.current) : $('body')

        const handleSelect = e => {
            onChange && onChange(e.params.data.id)
        }
        
        const options = {
            minimumResultsForSearch: -1,
            enoughRoomBelow: true,
            dropdownParent: parent,
        }
        if (escapeMarkup) options.escapeMarkup = markup => markup;
        if (!!formatListOptionCode) {
            const formatOption = getFormatOption(formatListOptionCode, items)
            if (formatOption) {
                options.templateResult = formatOption
                options.templateSelection = formatOption
            }
        }

        $(selectRef.current).select2(options);

        const styleDropdown = () => {
            if (!dropdownClass) return;
            $('body').find('.select2-dropdown').addClass(dropdownClass)
        };

        $(selectRef.current).on('select2:open', styleDropdown);
        $(selectRef.current).on('select2:select', handleSelect)

        return () => {
            $(selectRef.current).off('select2:select', handleSelect)
            $(selectRef.current).off('select2:open', styleDropdown)
            $(selectRef.current).select2('destroy')
        }
    }, [ onChange, items ])

    React.useEffect(() => {
        if (selectRef.current) {
            $(selectRef.current).val(value).trigger('change')
        }
    }, [ value ])

    return (
        <div ref={parentRef} className={cn(parentClass, error && errorClass)}>
            <select ref={selectRef} className={selectClass} value={value || ''} onChange={() => {}} disabled={disabled}>
                {!required && <option value=""></option>}
                {(items || []).map((e) => {
                    return <option key={`${keyPrefix}${e.id}`} disabled={e.count === 0} value={e.id}>
                        {e.title}
                    </option>
                })}
            </select>
        </div>
    )
}

function getFormatOption(code, items) {
    switch (code) {
        case 'sidebarCountPrice':
        default:
            return (option) => {

                if (option.id === undefined) return option.text;
                const item = items.find(e => e.id.toString() === option.id.toString());

                const $el = $(option.element);
                const disabled = $el.attr('disabled');

                return `
            <div class="el-option ${disabled ? 'disabled' : ''}">
                <span class="el-option__text">${option.text}</span>

                ${item?.count !== undefined && item?.count !== '' ? `<i class="el-option__count">(${item.count})</i>` : ''}

                ${item?.price > 0 && item?.price !== Infinity ? `<span class="el-option__price">${item.price.formatPrice(item.currency)}</span>` : ''}
            </div>
        `;
            }
    }
}